import { handleError, hasError, tryCatch } from '@repo/shared/api/helpers'
import { AuthPublicRoutes, AuthRoutes } from '@repo/shared/routes-auth'
import { AxiosInstance } from 'axios'

import { mockedData } from '@/store/mock/mock'
import { IApi } from '@/store/spi/api'

type T = {
  app: Omit<IApi['auth'], 'updateAccessToken'>
}

export const apiAuth: (api?: AxiosInstance) => T = (api): T => ({
  //
  // APP
  //
  app: {
    // TODO: getCurrent, patchPassword
    verify: api
      ? async (accessToken) => {
          const res = await tryCatch(
            async () =>
              await api.post<AuthPublicRoutes.verify.Response>(
                AuthPublicRoutes.verify.call(),
                accessToken satisfies AuthPublicRoutes.verify.Request,
              ),
          )
          if (hasError(res)) return handleError(res)
          return res
        }
      : () => {
          return Promise.resolve({ userId: mockedData.user.id })
        },

    patchCurrent: api
      ? async (fields) => {
          const res = await tryCatch(
            async () =>
              await api.patch<AuthRoutes.patchCurrent.Response>(
                AuthRoutes.patchCurrent.call(),
                fields satisfies AuthRoutes.patchCurrent.Request,
              ),
          )
          if (hasError(res)) return handleError(res)
          return res.user
        }
      : (p) => {
          return Promise.resolve({
            ...mockedData.user,
            ...p.fields,
          })
        },

    requestPasswordReset: api
      ? async ({ email }) => {
          const res = await tryCatch(
            async () =>
              await api.post<AuthPublicRoutes.requestPasswordReset.Response>(
                AuthPublicRoutes.requestPasswordReset.call(),
                {
                  email,
                } satisfies AuthPublicRoutes.requestPasswordReset.Request,
              ),
          )
          if (hasError(res)) return handleError(res)
          return true
        }
      : () => {
          return Promise.resolve(true)
        },

    resetPassword: api
      ? async ({ token, password, email }) => {
          const res = await tryCatch(
            async () =>
              await api.post<AuthPublicRoutes.resetPassword.Response>(
                AuthPublicRoutes.resetPassword.call(),
                {
                  token,
                  newPassword: password,
                  email,
                } satisfies AuthPublicRoutes.resetPassword.Request & {
                  email: string
                },
              ),
          )
          if (hasError(res)) return handleError(res)
          return true
        }
      : () => {
          return Promise.resolve(true)
        },
  },
})
